module.exports = "<app-menu-bar></app-menu-bar>\n<router-outlet></router-outlet>\n"